import { axiosBase, errorHandler } from "./axios";

const createEvent = (input: any) => {
    return axiosBase
        .post("/api/v1/events/create", input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const listEvents = (params: any) => {
    return axiosBase
        .post("/api/v1/events/list", params)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const viewEvent = (params: any) => {
    return axiosBase
        .get(`/api/v1/events/view/${params.id}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};
const updateEvent = (params: any) => {
    return axiosBase
        .put(`/api/v1/events/update/${params.id}`, params.body)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const assignMemberToEventsService = (params:any)=>{
 return axiosBase.post("/api/v1/events/assign-members", params)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
} 

const closeEvent = (params: any) => {
    return axiosBase
        .post(`/api/v1/events/close/${params.eventId}`, params.closureData)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const getEventsWithEnquiries = (id: string) => {
    return axiosBase
        .get(`/api/v1/events/events-with-enquiries/${id}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const updateEventStage = (params: { id: string; stage: string }) => {
    return axiosBase
        .patch(`/api/v1/events/update-stage/${params.id}`, { stage: params.stage })
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

export default {
  createEvent,
  listEvents,
  viewEvent,
  updateEvent,
  assignMemberToEventsService,
  closeEvent,
  getEventsWithEnquiries,
  updateEventStage,
};
